import React, { PropTypes } from 'react';
import { Collapse, ListGroup, ListGroupItem } from 'react-bootstrap';
import ShopSubCategoryList from './ShopSubCategoryList';

class ShopCategoryList extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         categoryOpen: -1
      };
      this.changeOpenCategory = this.changeOpenCategory.bind(this);
   }

   changeOpenCategory(categoryIndex) {
      this.setState({
         categoryOpen: (categoryIndex === this.state.categoryOpen) ? -1 : categoryIndex
      });
   }

   render() {
      const { categories, addCategory, addSubCategory, shopId } = this.props;
      const { categoryOpen } = this.state;
      return (
         <ListGroup>
            {categories.map((category, categoryIndex) => (
               <ListGroupItem key={category.id} className={categoryOpen === categoryIndex ? 'opened' : null} >
                  {
                     !category.subCategories ?
                        <span className="add-button" onClick={() => addCategory(shopId, category.id)} >add</span> : null
                  }
                  <span onClick={() => this.changeOpenCategory(categoryIndex)} >{category.name}</span>
                  <Collapse in={categoryOpen === categoryIndex} >
                     <div>
                        {category.subCategories
                        && <ShopSubCategoryList
                           subCategories={category.subCategories}
                           addSubCategory={addSubCategory}
                           categoryId={category.id}
                           shopId={shopId}
                        />}
                     </div>
                  </Collapse>
               </ListGroupItem>
            ))}
         </ListGroup>
      );
   }
}

ShopCategoryList.propTypes = {
   categories: PropTypes.array,
   shopId: PropTypes.number,
   addCategory: PropTypes.func,
   addSubCategory: PropTypes.func.isRequired,
};

export default ShopCategoryList;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainLocation/ShopCategoryList.js
 **/